// extracted by mini-css-extract-plugin
export default {"questionContainer":"PollQuestions_questionContainer__3BQTc","question":"PollQuestions_question__MQ2B1","pollAnswer":"PollQuestions_pollAnswer__H8eeP"};